/* eslint-disable */
import * as React from 'react';
import injectSheet from 'react-jss';

interface Props {
  currentStep?: number;
  currentStepId?: any;
  formTitle?: String;
  formSubTitle?: String;
  classes?: any;
  logo?: string;
}

const styleSheet = {
  container: {
    display: 'flex',
    fontFamily: 'CircularStd, sans-serif',
    textAlign: 'left',
    fontWeight: 'bold',
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 1.5,
    letterSpacing: 'normal',
    padding: '0 30px',
    '@media (max-width: 1024px)': {
      textAlign: 'center',
      paddingBottom: 0,
    },
  },
  containerH1: {
    fontFamily: 'MuseoSansBold, sans-serif',
    lineHeight: '60px',
    fontSize: '48px',
    fontWeight: 'bold',
    color: '#ffffff',
    margin: 0,
    opacity: 0,
    transform: 'translateY(10px)',
    animation: 'fadeInUp 0.6s ease-out forwards',
    animationDelay: '0.3s',
    animationDuration: '0.3s',
    '@media (max-width: 900px)': {
      fontSize: '26px',
      marginBottom: '10px',
      lineHeight: '32px',
      marginTop: '20px',
    },
  },
  containerH2: {
    fontSize: '24px',
    fontWeight: 500,
    color: '#ffffff',
  },
  logo: {
    maxWidth: '100%',
    maxHeight: '100%',
    objectFit: 'contain',
  },
  logoShaper: {
    width: '80px',
    height: '80px',
    overflow: 'hidden',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: 'white',
    borderRadius: '100%',
    padding: '10px',
    boxSizing: 'border-box',
    marginRight: '20px',
    transform: 'translateY(10px)',
    opacity: 0,
    animation: 'fadeInUp 0.6s ease-out forwards',
    animationDuration: '0.3s',
    animationDelay: '0.15s',
    '@media (max-width: 1024px)': {
      marginRight: 0,
    },
  },
  headerShaper: {
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    '@media (max-width: 1024px)': {
      flexDirection: 'column',
    },
  },
  '@keyframes fadeInUp': {
    from: {
      opacity: 0,
      transform: 'translateY(10px)',
    },
    to: {
      opacity: 1,
      transform: 'translateY(0)',
    },
  },
};

const WelcomeHeaderAppily: React.FC<Props> = props => {
  const [passedInLogo, setPassedInLogo] = React.useState(null);
  const [passedInTitle, setPassedInTitle] = React.useState(null);
  const [passedInSubTitle, setPassedInSubTitle] = React.useState(null);
  const [showLogo, setShowLogo] = React.useState(true);

  React.useEffect(() => {
    window.addEventListener('message', checkForMessage);
    return () => {
      window.removeEventListener('message', checkForMessage);
    };
  }, []);

  const checkForMessage = (event: any) => {
    if (event.data.message === 'updateLogo') {
      if (event.data.logoData) {
        setPassedInLogo(event.data.logoData);
        setShowLogo(true);
      } else {
        setShowLogo(false);
      }
    }
    if (event.data.message === 'welcomeCopy' && event.data.welcomeData) {
      setPassedInTitle(event.data.welcomeData.title);
      setPassedInSubTitle(event.data.welcomeData.subtitle);
    }
  };

  return (
    <div className={props.classes.container}>
      <div className={props.classes.headerShaper}>
        {(props.logo || passedInLogo) && showLogo && (
          <div className={props.classes.logoShaper}>
            <img
              className={props.classes.logo}
              src={passedInLogo || props.logo}
              data-object-fit="contain"
            />
          </div>
        )}
        <h1 className={props.classes.containerH1}>
          {passedInTitle ? (
            passedInTitle
          ) : (
            <>
              Welcome to
              <br />
              {props.formTitle}
            </>
          )}
        </h1>
      </div>
    </div>
  );
};

export default injectSheet(styleSheet)(WelcomeHeaderAppily);
